"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const commands_1 = __importDefault(require("components/Dashboard/TrackingPageEditor/Editor/commands"));
exports.default = (editor, config) => {
    const panelManager = editor.Panels;
    const { id, title, className } = config.command;
    // @ts-expect-error FIXME: Fields missing from ButtonOptions.
    panelManager === null || panelManager === void 0 ? void 0 : panelManager.addButton('options', {
        active: false,
        id,
        className,
        command: () => editor.runCommand(id, {}),
        attributes: { title }
    });
    (0, commands_1.default)(editor, config);
};
